import QueryRoutes from "./query";
import ReportingRoutes from "./reporting";
import ProducerInspectorsRoutes from "./producer_inspectors";

export default [
    ...QueryRoutes,
    ...ReportingRoutes,
    ...ProducerInspectorsRoutes,
];
